// extracted by mini-css-extract-plugin
export default {"throbber":"confirmationProcessForm-module__throbber__4YOPg"};